import { DragEvent } from "react";

import { DragOverPosition } from "./types";

/** Funkce pro vytvoření klíče pro DataTransfer objekt. */
export const createDataTransferKey = (key: string, itemId: string): string => `${key}:${itemId}`;

/** Vrací hodnotu ID dragovaného prvku */
export const getItemIdFromKey = (dataTransferKey: string): string => dataTransferKey.split(":")[1];

/** Vypočítává pozici kurzoru vůči prvku, nad kterým právě probíhá událost dragOver. */
export const getDragOverPosition = (e: DragEvent<HTMLElement>, ignoreMiddlePosition: boolean): DragOverPosition => {
    const rect = e.currentTarget.getBoundingClientRect();
    const height = rect.height;
    const y = e.clientY - rect.top; //y position within the element.

    if (ignoreMiddlePosition) {
        return y < height / 2 ? "Top" : "Bottom";
    }

    if (y < height / 3) {
        return "Top";
    }

    if (y > (height / 3) * 2) {
        return "Bottom";
    }

    return "Middle";
};
